import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { FeaturedLayout } from '../../layouts'
import { useEntregasData } from './entrega/useEntregasData'
import EstacionEntrega from './entrega/EstacionEntrega'

// Paso 3 del ciclo: quien necesita que talla.
//
// Antes vivia pegado al reparto en una sola entrada ("Tallas y entrega"), y son dos
// momentos separados por semanas y por el proveedor: aqui se captura para poder
// PEDIR; repartir es despues, cuando llega la caja. Sin talla la pieza ni siquiera
// existe (`jugadores_prendas.talla` es obligatorio), asi que este paso es el que
// destraba el pedido.
const TallasPage = () => {
  const [searchParams] = useSearchParams()
  const prendaIdInicial = searchParams.get('prenda') || ''
  const {
    matriz, grupos, temporadas, temporadaId, setTemporadaId,
    loading, reload, entregasDelPadron,
  } = useEntregasData()

  return (
    <FeaturedLayout
      title="Tallas"
      subtitle="Quién necesita qué talla. Sin esto no se puede mandar a hacer nada."
      refreshAction={reload}
    >
      {loading ? (
        <p className="py-8 text-center text-sm text-muted-foreground">Cargando...</p>
      ) : (
        <EstacionEntrega
          matriz={matriz}
          grupos={grupos}
          temporadas={temporadas}
          temporadaId={temporadaId}
          onTemporadaChange={setTemporadaId}
          prendaIdInicial={prendaIdInicial}
          entregasDelPadron={entregasDelPadron}
          onChanged={reload}
          conEntrega={false}
        />
      )}
    </FeaturedLayout>
  )
}

export default TallasPage
